import { changeDocumentDomainToCloud } from 'reactApp/utils/documentsDomain';

export const getSnackbarText = () => {
    const cloudDomainPath = `${changeDocumentDomainToCloud(window.location.origin)}/home/`;
    return [
        'Здесь вы можете работать с документами.<br>Ваши почтовые вложения находятся в ',
        `<a href="${cloudDomainPath}" rel="noopener" target="_blank">Облаке</a>.`,
    ].join(' ');
};
